import metaJson from 'metadata.json';
import { FEATURE_NAME_KEYS } from 'legacy/constants/constants';

export function getSupportedLocales() {
  if (!process.env.REACT_APP_I18N_SUPPORTED_LOCALES) {
    return ['en'];
  }
  return process.env.REACT_APP_I18N_SUPPORTED_LOCALES.split(',');
}

export function enableActionLogger() {
  return process.env.REACT_APP_MIDDLEWARE_ACTION_LOG === '1';
}

export function enableAnalytics() {
  return process.env.REACT_APP_ENABLE_ANALYTICS === '1';
}

export function getBuildVersion() {
  return metaJson.buildVersion;
}

export function getBuildDateTime() {
  return metaJson.buildDateTime;
}

export function getAppVersion() {
  return metaJson.release;
}

export function checkQtFeatureEnabled(me) {
  if (me && me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const qt = features && features.find(feat => feat.feature === 'qt');
    return qt ? qt.enabled : false;
  }

  return me.isFetching;
}

export function isQtDisplayFeatureEnabled(me, feature) {
  if (me && me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const qt = features && features.find(feat => feat.feature === feature);
    return qt ? qt.enabled : false;
  }

  return me.isFetching;
}

// hide QT Correction Type
export function checkHideQTCorrectionType(me, feature) {
  if (me && me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const hideqtcorrectiontype =
      features &&
      features.find(feat => feat.feature === 'hideqtcorrectiontype');
    return hideqtcorrectiontype ? hideqtcorrectiontype.enabled : false;
  }
  return me.isFetching;
}

export function checkRpmFeatureEnabled(me) {
  if (me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const rpm = features && features.find(feat => feat.feature === 'rpm');
    return rpm ? rpm.enabled : false;
  }
  return me.isFetching;
}

export function checkReferralFeatureEnabled(me) {
  if (me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const referral =
      features && features.find(feat => feat.feature === 'referral');
    return referral ? referral.enabled : false;
  }

  return me.isFetching;
}

export function checkReferralsOnlyFeatureEnabled(me) {
  if (me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const rpm = features && features.find(feat => feat.feature === 'rpm');
    const referral =
      features && features.find(feat => feat.feature === 'referral');
    const rpmEnabled = rpm ? rpm.enabled : false;
    const referralEnabled = referral ? referral.enabled : false;

    return referralEnabled && !rpmEnabled;
  }

  return me.isFetching;
}

export function checkServiceProviderFeatureEnabled(me) {
  if (me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const qtServiceProvider =
      features && features.find(feat => feat.feature === 'qt-service-provider');
    return qtServiceProvider ? qtServiceProvider.enabled : false;
  }

  return me.isFetching;
}

// function to check if NSR Notification is read
export function checkNSRNotificationStatus(me) {
  if (me.data) {
    const {
      profile: { settings },
    } = me.data;
    const nsrNotif = settings && settings.find(f => f.key === 'nsr_alert');
    return nsrNotif && nsrNotif.value;
  }

  return me.isFetching;
}

// function to check the service interpretation enabled or not
export function checkServiceInterpretationFeatureEnabled(me) {
  if (me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const interpretationServiceProvider =
      features &&
      features.find(feat => feat.feature === 'interpretation-service-provider');
    return (
      interpretationServiceProvider && interpretationServiceProvider.enabled
    );
  }

  return me.isFetching;
}

// function to check the service "kp-auto-ek12" enabled or not
export function checkKpAutoEk12FeatureEnabled(me) {
  if (me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const interpretationServiceProvider =
      features && features.find(feat => feat.feature === 'kp-auto-ek12');
    return (
      interpretationServiceProvider && interpretationServiceProvider.enabled
    );
  }

  return me.isFetching;
}

export function checkServiceProviderErrorFeatureEnabled(me) {
  if (me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const qtServiceProviderError =
      features && features.find(feat => feat.feature === 'kpsp-error');
    return qtServiceProviderError ? qtServiceProviderError.enabled : false;
  }

  return me.isFetching;
}

export function checkMedantaAPIFeatureEnabled(me) {
  if (me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const medantaAPIFeature =
      features && features.find(feat => feat.feature === 'medanta-api');
    return medantaAPIFeature ? medantaAPIFeature.enabled : false;
  }

  return me.isFetching;
}

export function getMedantaConfigs(me) {
  if (me.data) {
    const { teams } = me.data;
    const screeningConfig = teams ? teams[0].screeningConfig : null;
    let medantaConfig = screeningConfig.value;
    medantaConfig = medantaConfig != null && JSON.parse(medantaConfig);
    return medantaConfig;
  }

  return me.isFetching;
}

export function checkCRPFeatureEnabled(me) {
  if (me.data) {
    const { teams = [] } = me.data;
    const features = teams[0] ? teams[0].features : [];
    const crp = features.find(f => f.feature === FEATURE_NAME_KEYS.CRP) || {};
    return crp.enabled;
  }
  return me.isFetching;
}

// check teleconnect enabled
export function checkTKFeatureEnabled(me) {
  if (me.data) {
    const { teams = [] } = me.data;
    const features = teams[0] ? teams[0].features : [];
    const idtf = features.find(f => f.feature === FEATURE_NAME_KEYS.TK) || {};
    return idtf.enabled;
  }
  return me.isFetching;
}

// function to check the IDTF enabled or not
export function checkIdtfFeatureEnabled(me) {
  if (me.data) {
    const { teams = [] } = me.data;
    const features = teams[0] ? teams[0].features : [];
    const idtf = features.find(f => f.feature === FEATURE_NAME_KEYS.IDTF) || {};
    return idtf.enabled;
  }
  return me.isFetching;
}

// function to check the IDTF Service Provider enabled or not
export function checkIdtfServiceProviderFeatureEnabled(me) {
  if (me.data) {
    const featureName = FEATURE_NAME_KEYS.IDTF_SERVICE_PROVIDER;
    const { teams = [] } = me.data;
    const features = teams[0] ? teams[0].features : [];
    const provider = features.find(f => f.feature === featureName) || {};
    return provider.enabled;
  }
  return me.isFetching;
}

// function to check the Hide Overread Provider Info is enabled or not
export function shouldHideOverreadProviderInfo(me) {
  if (me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const hideOverreadProviderInfoFeature =
      features &&
      features.find(feat => feat.feature === 'hide-overread-provider-info');
    return (
      hideOverreadProviderInfoFeature && hideOverreadProviderInfoFeature.enabled
    );
  }
  return me.isFetching;
}

// function to check the Generalize Overread Provider Info is enabled or not
export function shouldGeneralizeOverreadProviderInfo(me) {
  if (me.data) {
    const { teams } = me.data;
    const features = teams ? teams[0].features : null;
    const generalizeOverreadProviderInfoEnabled =
      features &&
      features.find(
        feat => feat.feature === 'generalize-overread-provider-info',
      );
    return (
      generalizeOverreadProviderInfoEnabled &&
      generalizeOverreadProviderInfoEnabled.enabled
    );
  }
  return me.isFetching;
}

// Answers if the user has access to the inventory page
export function checkInventoryFeatureEnabled(me = {}) {
  let featureCheck = me.isFetching;
  if (me.data) {
    const { data: { teams: [{ features = [] } = {}] = [] } = {} } = me;
    featureCheck = features.find(f => f.feature === 'inventory');
  }
  return featureCheck;
}

// Answers if the user has access to the inventory report page
export function checkInventoryReportsFeatureEnabled(me = {}) {
  let featureCheck = me.isFetching;
  if (me.data) {
    const { data: { teams: [{ features = [] } = {}] = [] } = {} } = me;
    featureCheck = features.find(f => f.feature === 'inventory-reporting');
  }
  return featureCheck;
}

// Feature check for License Management
export function checkLicenseManagementEnabled(me = {}) {
  let featureCheck = me.isFetching;
  if (me.data) {
    const { data: { teams: [{ features = [] } = {}] = [] } = {} } = me;
    featureCheck = features.find(f => f.feature === 'license-management');
  }
  return featureCheck;
}



// WEBPACK FOOTER //
// ./src/configs/index.js